export const BiCoSupportIcon = ({ height = '35', width = '35', className = '' }) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 35 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="35" height="35" rx="4" fill="#DFF800" />
      <path
        d="M16.7792 9.24949C17.1727 8.84038 17.8273 8.84038 18.2208 9.24949L19.4045 10.4803C19.6189 10.7033 19.9243 10.8144 20.2318 10.7815L21.9298 10.5995C22.4941 10.539 22.9957 10.9598 23.0341 11.5261L23.1497 13.2298C23.1706 13.5384 23.3331 13.8199 23.5899 13.9923L25.0076 14.9443C25.4788 15.2607 25.5925 15.9055 25.2579 16.364L24.2513 17.7434C24.069 17.9933 24.0126 18.3134 24.0984 18.6105L24.5725 20.251C24.7301 20.7963 24.4028 21.3633 23.8518 21.4995L22.194 21.9092C21.8937 21.9834 21.6447 22.1923 21.5195 22.4751L20.8281 24.0366C20.5984 24.5556 19.9832 24.7795 19.4735 24.5296L17.9402 23.7778C17.6625 23.6417 17.3375 23.6417 17.0598 23.7778L15.5265 24.5296C15.0168 24.7795 14.4016 24.5556 14.1719 24.0366L13.4805 22.4751C13.3553 22.1923 13.1063 21.9834 12.806 21.9092L11.1483 21.4995C10.5972 21.3633 10.2699 20.7963 10.4275 20.251L10.9016 18.6105C10.9874 18.3134 10.931 17.9933 10.7487 17.7434L9.74208 16.364C9.4075 15.9055 9.52118 15.2607 9.9924 14.9443L11.4101 13.9923C11.6669 13.8199 11.8294 13.5384 11.8503 13.2298L11.9659 11.5261C12.0043 10.9598 12.5059 10.539 13.0702 10.5995L14.7682 10.7815C15.0757 10.8144 15.3811 10.7033 15.5955 10.4803L16.7792 9.24949Z"
        fill="#05050D"
      />
      <path
        d="M17.4959 12.9653L18.8567 15.6823L21.5793 17.041L18.8567 18.3997L17.4959 21.1167L16.1352 18.3997L13.4126 17.041L16.1352 15.6823L17.4959 12.9653Z"
        fill="#DFF800"
      />
    </svg>
  );
};
